import { createFileRoute, notFound } from "@tanstack/react-router";

import { FeedbackClient } from "@/booking/feedback/FeedbackClient";
import { getBookingByFeedbackTokenFn } from "@/server-fns/booking/serverFns";

export const Route = createFileRoute("/booking/feedback/$token")({
    // Lets the thank-you email's one-tap star links (`?rating=N`) pre-select a rating so the
    // guest lands on the form ready to submit instead of starting from a blank state. The
    // router's default search parser JSON-parses numeric-looking values, so `?rating=4` can
    // arrive as either the number 4 or the string "4" depending on the raw query text.
    validateSearch: (search) => {
        const parsed = Number(search.rating);
        return {
            rating: Number.isInteger(parsed) && parsed >= 1 && parsed <= 5 ? parsed : undefined,
        };
    },
    loader: async ({ params }) => {
        const booking = await getBookingByFeedbackTokenFn({
            data: { token: params.token },
        });
        if (!booking) {
            throw notFound();
        }
        return { booking };
    },
    component: RouteComponent,
});

function RouteComponent() {
    const { token } = Route.useParams();
    const { booking } = Route.useLoaderData();
    const { rating } = Route.useSearch();

    return <FeedbackClient booking={booking} token={token} initialRating={rating} />;
}
